// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__LlEt3","label":"Category_label__3bRRZ","content":"Category_content__3clls","header":"Category_header__3_jKp","location":"Category_location__t4kD2"};